// Generación de audio Speech-to-Speech: manda el audio del usuario + la voz
// elegida al webhook generar_audio_creator (rama dialogo_input_mode:"audio")
// y registra el resultado como asset de audio del proyecto.
import { GENERATE_AUDIO_CREATOR_URL, GENERATE_AUTH_TOKEN } from "../config";
import { registerExistingAsset } from "../utils/projectAssets";

export interface GenerateS2SParams {
  projectId: string;
  companyId: string;
  userId: string;
  voiceId: string;
  audioUrl: string;
  audioDurationSec: number;
}

export async function generateS2SAudio(
  params: GenerateS2SParams,
): Promise<void> {
  let res: Response;
  try {
    res = await fetch(GENERATE_AUDIO_CREATOR_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: GENERATE_AUTH_TOKEN,
      },
      body: JSON.stringify({
        user_id: params.userId,
        ref_mode: "voz",
        voz_id: params.voiceId,
        project_id: params.projectId,
        velocidad_voz: 1.0,
        dialogo_input_mode: "audio",
        audio_url: params.audioUrl,
        audio_duration_sec: params.audioDurationSec,
      }),
      signal: AbortSignal.timeout(300_000),
    });
  } catch (e: any) {
    if (e?.name === "TimeoutError" || e?.name === "AbortError") {
      throw new Error("La generación tardó demasiado. Probá de nuevo.");
    }
    throw new Error("No se pudo conectar. Revisá tu conexión.");
  }
  if (!res.ok) {
    throw new Error(`Error del servidor (${res.status}).`);
  }
  const json = (await res.json()) as {
    response?: string;
    path?: string;
    error?: string;
  };
  if (json.response !== "success" || !json.path) {
    throw new Error(json.error || "La generación de audio falló.");
  }
  // Registrar el audio generado (el backend ya lo escribió en storage) como
  // asset del proyecto, para que el plugin lo pueda listar e importar.
  await registerExistingAsset({
    projectId: params.projectId,
    companyId: params.companyId,
    userId: params.userId,
    storagePath: json.path,
    type: "audio",
    name: "Voz IA (grabada)",
    durationSeconds: params.audioDurationSec,
  });
}
